import { apiFetch } from "@/api/client";
import { ENDPOINTS } from "@/api/endpoints";
import type {
  AlertClearScope,
  Alert,
  AlertCounts,
  AlertStatus,
  AlertListParams,
  AlertsPage,
  CreateAlertPayload,
} from "./types";

export function listAlerts(params?: AlertListParams): Promise<AlertsPage> {
  const qs = new URLSearchParams({
    limit: String(params?.limit ?? 50),
    offset: String(params?.offset ?? 0),
  });
  if (params?.status) qs.set("status", params.status);
  if (params?.type) qs.set("type", params.type);
  if (params?.search?.trim()) qs.set("search", params.search.trim());
  return apiFetch(`${ENDPOINTS.alerts.list}?${qs}`);
}

export function listTrayAlerts(params?: AlertListParams): Promise<AlertsPage> {
  const qs = new URLSearchParams({
    limit: String(params?.limit ?? 50),
    offset: String(params?.offset ?? 0),
  });
  if (params?.view) qs.set("view", params.view);
  if (params?.type) qs.set("type", params.type);
  if (params?.search?.trim()) qs.set("search", params.search.trim());
  return apiFetch(`${ENDPOINTS.alerts.tray}?${qs}`, { method: "GET" });
}

export function countAlerts(): Promise<AlertCounts> {
  return apiFetch(ENDPOINTS.alerts.count);
}

export function createAlert(payload: CreateAlertPayload): Promise<Alert> {
  return apiFetch(ENDPOINTS.alerts.create, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateAlertStatus(
  id: string,
  status: AlertStatus,
): Promise<Alert> {
  return apiFetch(ENDPOINTS.alerts.updateStatus(id), {
    method: "PATCH",
    body: JSON.stringify({ status }),
  });
}

export function updateAlertNote(id: string, note: string): Promise<Alert> {
  return apiFetch(ENDPOINTS.alerts.updateNote(id), {
    method: "PATCH",
    body: JSON.stringify({ note }),
  });
}

export function clearAlerts(
  scope: AlertClearScope = "all",
): Promise<{ updated: number }> {
  return apiFetch(
    `${ENDPOINTS.alerts.clear}?${new URLSearchParams({ scope })}`,
    { method: "PATCH" },
  );
}
